var map = {
	"./num-0.png": "NJZ4",
	"./num-1.png": "u3I4",
	"./num-2.png": "1D6T",
	"./num-3.png": "4+l+",
	"./num-4.png": "fHel",
	"./num-5.png": "cHA+",
	"./num-6.png": "3fu/",
	"./num-7.png": "KbZR",
	"./num-8.png": "+cKD",
	"./num-9.png": "jkSv",
	"./num-bg.png": "1Zr1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sIcg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage ^\.\/num\-.*\.png$
// module id = sIcg
// module chunks = 1